import queryString from "query-string";
import React, { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { getEnvironment } from "@utils/configuration/aem";
import { Environments } from "@utils/general";

import FeatureToggles, {
    FeatureToggleKeys,
} from "@services/featureToggles.services";

import { getProductComparisonSkuList } from "@redux/modules/value/productComparisonSkuList/productComparisonSkuList.selectors";
import { getProductDetail } from "@redux/modules/value/productDetail/productDetail.selectors";

import { FeatureSwitchComponent } from "./featureSwitch.component";
import "./featureSwitch.scss";

const FeatureSwitchContainer = () => {
    const hasComparison = !!useSelector(getProductComparisonSkuList)?.length;
    const hasOrderButton = useSelector(
        getProductDetail,
        shallowEqual,
    ).stickyOrderButton;
    const [isOpen, setIsOpen] = React.useState(false);
    const [features, setFeatures] = React.useState<
        Array<{ name: FeatureToggleKeys; value: boolean }>
    >([]);

    useEffect(() => {
        setFeatures(
            Object.values(FeatureToggleKeys).map(key => ({
                name: key as FeatureToggleKeys,
                value: FeatureToggles.getFeature(key as FeatureToggleKeys)
                    .enabled,
            })),
        );
    }, []);

    const toggleDrawer = (state?: boolean) => {
        if (state !== undefined) {
            setIsOpen(state);
            return;
        }

        setIsOpen(state => !state);
    };

    const isEnabled =
        getEnvironment() !== Environments.PROD &&
        (FeatureToggles.isEnabled(FeatureToggleKeys.FEATURE_SWITCH_UI) ||
            queryString.parse(location.search, { parseBooleans: true })
                .featureswitchui);

    if (!isEnabled) {
        return null;
    }

    return (
        <FeatureSwitchComponent
            isOpen={isOpen}
            onToggle={toggleDrawer}
            features={features}
            onToggleFeature={(name, value) => {
                FeatureToggles.setFeature(name, value);
                setFeatures(state =>
                    state.map(f => (f.name === name ? { ...f, value } : f)),
                );
            }}
            bottomControlsVisible={hasComparison || hasOrderButton}
        />
    );
};

export { FeatureSwitchContainer };
